<template>
    <table-row>
        <table-cell>
            {{ store.name }}
        </table-cell>
        <table-cell>
            <icon v-if="hasBudget()" :size="6" name="check-circle"
                  class-icon="text-green-600"></icon>
            <icon v-else :size="6" name="x-circle" class-icon="text-red-600"></icon>
        </table-cell>
        <table-cell>
            <icon v-if="hasProjection()" :size="6" name="check-circle"
                  class-icon="text-green-600"></icon>
            <icon v-else :size="6" name="x-circle" class-icon="text-red-600"></icon>
        </table-cell>
        <table-cell>
            {{ getExtrapolationCount() }} / {{ $helper.getExtrapolationCountForMonth(year, month) }}
        </table-cell>
        <table-cell>
            <icon v-if="hasProfitAndLoss()" :size="6" name="check-circle"
                  class-icon="text-green-600"></icon>
            <icon v-else :size="6" name="x-circle" class-icon="text-red-600"></icon>
        </table-cell>
        <table-cell>
            <icon v-if="hasActual()" :size="6" name="check-circle"
                  class-icon="text-green-600"></icon>
            <icon v-else :size="6" name="x-circle" class-icon="text-red-600"></icon>
        </table-cell>
        <table-cell class="flex justify-end space-x-1">
            <edit-button :href="route('stores.profit-and-loss.edit', [store.id, year, month])"/>
        </table-cell>
    </table-row>
</template>

<script>
export default {
    props: {
        store: {
            type: Object,
        },
    },

    data() {
        return {
            year: moment.utc().year(),
            month: moment.utc().month() + 1,
        };
    },

    methods: {
        hasBudget() {
            return this.store.budgets && this.store.budgets.length > 0;
        },

        hasProjection() {
            return this.store.projections && this.store.projections.length > 0;
        },

        getExtrapolationCount() {
            return this.store.extrapolations.length;
        },

        hasProfitAndLoss() {
            return this.store.profit_and_losses && this.store.profit_and_losses.length > 0;
        },

        hasActual() {
            return this.store.actuals && this.store.actuals.length > 0;
        },
    },
};
</script>

<style scoped>

</style>
